import { render, staticRenderFns } from "./gSide.vue?vue&type=template&id=784bb54e&scoped=true&"
import script from "./gSide.vue?vue&type=script&lang=js&"
export * from "./gSide.vue?vue&type=script&lang=js&"
import style0 from "./gSide.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gSide.vue?vue&type=style&index=1&id=784bb54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784bb54e",
  null
  
)

export default component.exports